import { Datagrid, ListProps, ReferenceField, SelectField, TextField } from 'react-admin';
import { CustomList, MediaField, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function UtilitiesList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody filterColumn="category" />} rowClick="edit">
        <MediaField label="Ícone" source="icon" sortable={false} />

        <TextField label="Nome" source="name" sortable={false} />

        <ReferenceField
          label="Categoria"
          source="category"
          reference="utility-categories"
          sortable={false} 
        >
          <TextField source="name" />
        </ReferenceField>

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
